import { render, staticRenderFns } from "./PolicyModal.vue?vue&type=template&id=54539399&scoped=true&"
import script from "./PolicyModal.vue?vue&type=script&lang=js&"
export * from "./PolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./PolicyModal.vue?vue&type=style&index=0&id=54539399&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54539399",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54539399')) {
      api.createRecord('54539399', component.options)
    } else {
      api.reload('54539399', component.options)
    }
    module.hot.accept("./PolicyModal.vue?vue&type=template&id=54539399&scoped=true&", function () {
      api.rerender('54539399', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modal/PolicyModal.vue"
export default component.exports